/**
 * Swim skills organized by swim level.
 *
 * These skills are used in the coach attendance workflow
 * to track which skills were practiced during each class.
 */

export const SWIM_SKILLS_BY_LEVEL: Record<string, string[]> = {
  Bubble: [
    "water_comfort",
    "face_in_water",
    "bubble_blowing",
    "assisted_floating",
    "kicking_with_board",
  ],
  "Tot (Ages 3-4 years)": [
    "water_comfort",
    "bubble_blowing",
    "back_floating_assisted",
    "front_kicking",
    "arm_scoops",
  ],
  Star: [
    "face_in_water_5sec",
    "back_float_unassisted",
    "front_glide",
    "basic_arm_strokes",
    "rhythmic_breathing",
  ],
  Kicker: [
    "streamline_position",
    "flutter_kick",
    "back_float_10sec",
    "front_crawl_arms",
    "rotary_breathing",
  ],
  Roller: [
    "front_crawl_25m",
    "back_crawl_basics",
    "flip_to_back",
    "treading_water",
    "diving_basics",
  ],
  Puller: [
    "front_crawl_50m",
    "back_crawl_25m",
    "breaststroke_kick",
    "side_breathing",
    "underwater_swimming",
  ],
  Charger: [
    "butterfly_kick",
    "breaststroke_25m",
    "backstroke_25m",
    "flip_turns",
    "diving_blocks",
  ],
  "Delta (Level 9 - Level 12)": [
    "butterfly_25m",
    "im_basics",
    "racing_starts",
    "open_turns",
    "endurance_100m",
  ],
  "Gamma (Level 13 - Level 16)": [
    "butterfly_50m",
    "im_100m",
    "sprint_technique",
    "pace_training",
    "competition_prep",
  ],
  Challenge: [
    "stroke_refinement",
    "distance_training",
    "race_strategy",
    "mental_preparation",
  ],
  "Intermediate(was Pre-Competitive)": [
    "all_strokes_legal",
    "relay_starts",
    "pacing",
    "meet_preparation",
  ],
  "Advance (was Competitive)": [
    "race_analysis",
    "advanced_starts",
    "underwater_dolphins",
    "competition_mindset",
  ],
}

/**
 * Convert skill key to human-readable label
 */
export function getSkillLabel(skillKey: string): string {
  return skillKey
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}

/**
 * Get skills for a given swim level
 */
export function getSkillsForLevel(level: string): string[] {
  return SWIM_SKILLS_BY_LEVEL[level] || []
}
